import { plasma } from 'viem/chains'
import { type Client, createClient } from '../../client'
import type { Explorer } from '../../explorer'
import { createEtherscanV2 } from '../../explorer'
import type { Chain } from '../types/chain'
import type { HttpRpc } from '../types/rpc'

export const createPlasmaChain = ({
  explorerApiKey: apiKey,
  explorerProxyUrl: proxyUrl,
  explorerPageSize: pageSize,
}: {
  explorerApiKey?: string
  explorerProxyUrl?: string
  explorerPageSize?: number
}) =>
  createPlasmaChainCustom({
    client: createClient({
      chain: plasma,
      httpRpcs: plasmaHttpRpcs,
    }),
    explorer: createEtherscanV2({
      name: 'Plasmascan',
      baseUrl: 'https://plasmascan.to',
      chainId: 9745,
      apiKey,
      proxyUrl,
      pageSize,
    }),
  })

type CreatePlasmaChainParameters = {
  client: Client
  explorer: Explorer
}

export const createPlasmaChainCustom = ({
  client,
  explorer,
}: CreatePlasmaChainParameters): Chain => ({
  id: 9745,
  network: 'plasma',
  name: 'Plasma',
  nativeToken: {
    name: 'Plasma',
    symbol: 'XPL',
    decimals: 18,
    currency: {
      symbol: 'XPL',
      type: 'CryptoCurrency',
      id: 'plasma',
      name: 'Plasma',
      updatedAt: 0,
    },
  },
  wrappedTokenAddresses: new Set([
    '0x6100e367285b01f48d07953803a2d8dca5d19873',
  ]),
  explorer,
  client,
  blockTime: 1000,
  coingeckoId: 'plasma',
  defillamaId: undefined,
})

export const plasmaHttpRpcs: HttpRpc[] = [
  {
    url: 'https://plasma.drpc.org',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
  {
    url: 'https://rpc.plasma.to',
    getLogsIsUsable: true,
    getLogsMaxBlockRange: 10_000n,
  },
]

export const plasmaWebsocketRpcUrls: readonly string[] = [
  'wss://plasma.drpc.org',
]
